/**
 * SelectRedirect
 * ======================================
 * - redirect to selected value
 */

const ELEMENTS = ".js-SelectRedirect";

class SelectRedirect {
  constructor() {
    this.elements = document.querySelectorAll(ELEMENTS);

    if (!this.elements) {
      return false;
    }

    this.elements.forEach((el) => {
      el.addEventListener("change", this.redirect);
    });
  }

  redirect = (e) => {
    const el = e.currentTarget;

    window.location.href = el.value;
  };
}

new SelectRedirect();
